import { z } from 'zod';
import { DateOnlySchema, IdSchema, PageInfoSchema, TimestampSchema } from './common.js';
export const DashboardSummarySchema = z.strictObject({
    companies: z.number().int().nonnegative(),
    openLeads: z.number().int().nonnegative(),
    openOpportunities: z.number().int().nonnegative(),
    activeProjects: z.number().int().nonnegative(),
    overdueTasks: z.number().int().nonnegative(),
    unreadNotifications: z.number().int().nonnegative(),
});
export const ReportTypeSchema = z.enum([
    'companies',
    'contacts',
    'leads',
    'opportunities',
    'projects',
    'tasks',
    'job_drying_log',
    'job_estimate_handoff',
]);
export const ReportExportFormatSchema = z.enum(['csv', 'json', 'pdf']);
/** Parameters a report definition may require; the server validates them per report type. */
export const ReportParametersSchema = z.strictObject({
    jobFileId: IdSchema.optional(),
});
export const ReportExportStatusSchema = z.enum([
    'pending',
    'processing',
    'completed',
    'failed',
    'expired',
]);
export const CreateReportExportRequestSchema = z.strictObject({
    reportType: ReportTypeSchema,
    format: ReportExportFormatSchema.default('csv'),
    parameters: ReportParametersSchema.default({}),
    fromDate: DateOnlySchema.nullable().default(null),
    toDate: DateOnlySchema.nullable().default(null),
});
export const ReportExportSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    requestedByMembershipId: IdSchema,
    reportType: ReportTypeSchema,
    format: ReportExportFormatSchema,
    parameters: z.record(z.string(), z.unknown()),
    status: ReportExportStatusSchema,
    fromDate: DateOnlySchema.nullable(),
    toDate: DateOnlySchema.nullable(),
    fileName: z.string().nullable(),
    failureCode: z.string().nullable(),
    expiresAt: TimestampSchema.nullable(),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
});
export const ReportExportListSchema = z.strictObject({
    items: z.array(ReportExportSchema),
    page: PageInfoSchema,
});
export const ReportExportDownloadSchema = z.strictObject({
    url: z.url(),
    expiresAt: TimestampSchema,
});
